import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const Dot = ({ ok, warn }) => <span className={`inline-block h-2.5 w-2.5 rounded-full ${ok ? "bg-emerald-500" : warn ? "bg-amber-500" : "bg-red-500"}`} aria-hidden />;
const KEY = { configured: "Configured", missing: "Not added yet", wrong_type: "Wrong key type", invalid_characters: "Invalid – key looks truncated or contains unexpected characters; re-paste the full key" };
const REASON = {
  disabled: "valuation mode is Disabled", not_public: "sandbox mode is private to signed-in staff",
  key_not_configured: "the API key for this mode is missing", baseline_not_configured: "no trade baseline field selected yet",
};

export const SettingsPanel = ({ title, children, testid }) => (
  <section className="panel space-y-4 p-4 sm:p-5" data-testid={testid}><h2 className="text-lg font-extrabold text-slate-900">{title}</h2>{children}</section>
);

export const IntegrationStatus = ({ tick }) => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/dealer/integrations").then((r) => setD(r.data)).catch(() => {}); }, [tick]);
  if (!d) return null;
  const v = d.valuation;
  return (
    <div className="grid gap-3 md:grid-cols-3" data-testid="integration-status">
      <div className="panel p-4 text-sm">
        <p className="font-bold">Valuation API (DealerPricing)</p>
        <p className="mt-2 flex items-center gap-2"><Dot ok={v.keys.sandbox === "configured"} warn={v.keys.sandbox === "missing"} />Sandbox key: {KEY[v.keys.sandbox]}</p>
        <p className="flex items-center gap-2"><Dot ok={v.keys.live === "configured"} warn={v.keys.live === "missing"} />Live key: {KEY[v.keys.live]}</p>
        <p className="mt-1">Mode: <strong data-testid="integration-mode">{v.mode}</strong></p>
        <p className="mt-1" data-testid="public-valuation-status">Public estimates: {v.public.available ? <strong className="text-emerald-700">On</strong> : <>Off – {REASON[v.public.reason] || v.public.reason}</>}</p>
      </div>
      <div className="panel p-4 text-sm">
        <p className="font-bold">Email</p>
        <p className="mt-2 flex items-center gap-2"><Dot ok={d.email.configured} />{d.email.configured ? "Sending configured (Emergent managed sender)" : "Not configured"}</p>
        <p className="mt-1">Notifications to: {d.email.recipient}</p>
        {d.email.last_event && <p className="mt-1" data-testid="last-email-event">Last email: {d.email.last_event.ok ? "sent" : `failed (${d.email.last_event.error})`} · {new Date(d.email.last_event.at).toLocaleString("en-GB")}</p>}
      </div>
      <div className="panel p-4 text-sm">
        <p className="font-bold">Private photo storage</p>
        <p className="mt-2 flex items-center gap-2"><Dot ok={d.storage.ok} />{d.storage.ok ? "Connected" : `Not connected${d.storage.error ? ` (${d.storage.error})` : ""}`}</p>
        <p className="mt-1 text-slate-600">Photos are only served to signed-in staff.</p>
      </div>
    </div>
  );
};
